import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { fetchProjects } from "../../lib/api";
import "./ProjectsTeaser.css";
import VirtualStudio from "../ui/vssmall.svg";
import VirtualProductions from "../ui/VirtualProductions.svg";
import IntelliTrack from "../ui/IntelliTrack.svg";
import ImmersiveExp from "../ui/ImmersiveExp.svg";
import IntExh from "../ui/IntEx.svg";
import DefenceImg from '../ui/defence.svg';
import DroneImg from '../ui/dronemed.svg'


const LOCAL_IMAGES = {
    "virtualstudio.svg": VirtualStudio,
    "VirtualProductions.svg": VirtualProductions,
    "IntelliTrack.svg": IntelliTrack,
    "ImmersiveExp.svg": ImmersiveExp,
    "IntExh.svg": IntExh,
    "Defence.svg": DefenceImg,
    "Drone.svg": DroneImg,
    "defence.svg": DefenceImg,
    "drone.svg": DroneImg,
};

const getImageUrl = (p) => {
    const title = (p.title || "").toLowerCase();
    if (title.includes("tactical") || title.includes("combat")) return DefenceImg;
    if (title.includes("drone")) return DroneImg;
    return LOCAL_IMAGES[p.image_url] || p.image_url;
};

export const ProjectsTeaser = () => {

    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [expandedIds, setExpandedIds] = useState({});

    const toggleExpand = (id, e) => {
        e.stopPropagation();
        setExpandedIds(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    useEffect(() => {
        let active = true;
        fetchProjects()
            .then((data) => {
                if (active) setProjects(data.slice(0, 4));
            })
            .catch((e) => console.error("projects fetch failed", e))
            .finally(() => active && setLoading(false));
        return () => {
            active = false;
        };
    }, []);

    return (
        <section
            data-testid="projects-teaser-section"
            className="teaser-section py-5 py-md-10 border-top"
        >
            <div className="container-db">
                <div className="d-flex flex-column flex-md-row align-items-md-end justify-content-between gap-4 mb-5">
                    <div>
                        <div className="font-mono-tech section-eyebrow mb-4 fade-in-up fs-5">
                            ⟶ Featured Missions
                        </div>
                        <h2 className="font-heading section-heading mb-0">
                            Bringing Ideas to Life

                        </h2>
                    </div>
                    <Link
                        to="/projects"
                        data-testid="projects-view-all"
                        className="immersive-link font-mono-tech text-decoration-none align-self-start"
                    >
                        View All Projects <ArrowUpRight size={16} />
                    </Link>
                </div>

                {loading ? (
                    <div className="row g-3">
                        {[...Array(4)].map((_, i) => (
                            <div key={i} className="col-12 col-md-6">
                                <div className="teaser-card-pulse" />
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="row g-3">
                        {projects.map((p, i) => (
                            <div key={p.id} className="col-12 col-md-6">
                                <article
                                    data-testid={`project-card-${p.id}`}
                                    className="position-relative overflow-hidden group-hover-parent teaser-card bg-dark"
                                >
                                    <div
                                        className="teaser-card-img bg-cover bg-center"
                                        style={{ backgroundImage: `url(${getImageUrl(p)})` }}
                                    />
                                    {!(p.title.toLowerCase().includes("tactical") || p.title.toLowerCase().includes("combat") || p.title.toLowerCase().includes("drone")) && (
                                        <div className="teaser-overlay" />
                                    )}

                                    <div className="position-relative h-100 p-3 d-flex flex-column justify-content-between teaser-card-content">
                                        <div className="d-flex align-items-center justify-content-between mb-2">

                                            <div className="font-mono-tech defence-label-top fs-5 fw-bold">
                                                {p.title}
                                            </div>
                                        </div>

                                        <div>

                                            <p
                                                className={`card-desc max-w-xl ${expandedIds[p.id] ? "is-expanded" : ""}`}
                                                onClick={(e) => toggleExpand(p.id, e)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                {p.description}
                                            </p>
                                        </div>
                                    </div>
                                </article>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
};



export default ProjectsTeaser;
